import React, { lazy } from 'react';
import {
	accounts,
	complains,
	consignee,
	containers,
	customers,
	damageClaim,
	dashboardMenu,
	demoPages,
	exports,
	layoutMenu,
	loadPlan,
	price,
	pricing,
	profiles,
	settings,
	vehicles,
} from '../menu';
import Login from '../pages/presentation/auth/Login';

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/dashboard/DashboardPage')),
};
const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};
const PAGE_LAYOUTS = {
	HEADER_SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/HeaderAndSubheader')),
	HEADER: lazy(() => import('../pages/presentation/page-layouts/OnlyHeader')),
	SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/OnlySubheader')),
	CONTENT: lazy(() => import('../pages/presentation/page-layouts/OnlyContent')),
	BLANK: lazy(() => import('../pages/presentation/page-layouts/Blank')),
	ASIDE: lazy(() => import('../pages/presentation/aside-types/DefaultAsidePage')),
	MINIMIZE_ASIDE: lazy(() => import('../pages/presentation/aside-types/MinimizeAsidePage')),
};

const SETTINGS = {
	USER: lazy(() => import('../pages/settings/users/User')),
	USER_ROLE: lazy(() => import('../pages/settings/users/UserPermission')),
	ROLE: lazy(() => import('../pages/settings/roles/Role')),
	ROLE_UPDATE: lazy(() => import('../pages/settings/roles/UserRoleUpdate')),
	COUNTRY: lazy(() => import('../pages/settings/countries/Country')),
	STATE: lazy(() => import('../pages/settings/states/State')),
	CITY: lazy(() => import('../pages/settings/cities/City')),
	LOCATION: lazy(() => import('../pages/settings/locations/Location')),
	STREAMSHIP_LINE: lazy(() => import('../pages/settings/streamship_lines/StreamshipLine')),
	AUDIT: lazy(() => import('../pages/settings/audit/Audit')),
	SHOWLOG: lazy(() => import('../pages/settings/audit/ShowLog')),
};

const ACCOUNTS = {
	VEHICLE_INVOICE: lazy(() => import('../pages/accounts/vehicle-invoce/VehicleInvoice')),
	SERVICE_INVOICE: lazy(() => import('../pages/accounts/service-invoice/ServiceInvoice')),

	INVOICE_SUMMARY: lazy(() => import('../pages/invoices/InvoiceSummary')),
	PAID_INVOICE: lazy(() => import('../pages/paidInvoice/PaidInvoice')),
	PARTIAL_PAID_INVOICE: lazy(() => import('../pages/partialPaidInvoice/PartialPaidInvoice')),
	UNPAID_INVOICE: lazy(() => import('../pages/unpaidInvoice/UnpaidInvoice')),
	INVOICES: lazy(() => import('../pages/invoices/Invoice')),
};

const VEHICLES = {
	VEHICLE: lazy(() => import('../pages/vehicles/Vehicles')),
	SHOWVEHICLE: lazy(() => import('../pages/vehicles/ShowVehicle')),
};
const NOTES = {
	NOTE: lazy(() => import('../pages/notes/Notes')),
};

const PORTS = {
	PORT: lazy(() => import('../pages/settings/ports/Ports')),
	// SHOWVEHICLE: lazy(() => import('../pages/vehicles/ShowVehicle')),
};

const PORT_OF_LOADING = {
	PORT_LOADING: lazy(() => import('../pages/settings/port_of_loading/PortOfLoading')),
	// SHOWVEHICLE: lazy(() => import('../pages/vehicles/ShowVehicle')),
};

const PORT_OF_DISCHARGE = {
	PORT_DISCHARGE: lazy(() => import('../pages/settings/port_of_discharge/PortOfDischarge')),
	// SHOWVEHICLE: lazy(() => import('../pages/vehicles/ShowVehicle')),
};

const EXPORTS = {
	EXPORTS: lazy(() => import('../pages/exports/Exports')),
	SHOWEXPORT: lazy(() => import('../pages/exports/ShowExport')),
};

const CONSIGNEES = {
	CONSIGNEE: lazy(() => import('../pages/consignees/Consignee')),
	SHOWCONSIGNEE: lazy(() => import('../pages/consignees/ShowConsignee')),
};

const NOTIFICATIONS = {
	NOTIFICATION: lazy(() => import('../pages/notifications/Notifications')),
	SHOW_NOTIFICATION: lazy(() => import('../pages/notifications/ShowNotification')),
};

const PROFILES = {
	PROFILE: lazy(() => import('../pages/profile/Profile')),
};

const CUSTOMERS = {
	CUSTOMER: lazy(() => import('../pages/customers/Customers')),
	SHOW_CUSTOMER: lazy(() => import('../pages/customers/ShowCustomer')),
};
const CONTAINERS = {
	CONTAINER: lazy(() => import('../pages/container/Containers')),
};
const DAMAGECLAIMS = {
	DAMAGECLAIM: lazy(() => import('../pages/damageClaim/DamageClaim')),
	DAMAGECLAIM_SHOW: lazy(() => import('../pages/damageClaim/ShowDamageClaim')),
};
const PRICHING = {
	PRICHING: lazy(() => import('../pages/pricing/Priching')),
};
const PRICES = {
	CLEARANCE: lazy(() => import('../pages/pricing/ClearanceRate/ClearanceRate')),
	SHIPPINGRATE: lazy(() => import('../pages/shippingRate/ShippingRate')),
	SHOWSHIPPINGRATE: lazy(() => import('../pages/shippingRate/ShowShippingRate')),
	TOWING: lazy(() => import('../pages/towingRate/TowingRate')),
	SHOWTOWINGRATE: lazy(() => import('../pages/towingRate/ShowTowingRate')),
	PRICES: lazy(() => import('../pages/prices/Prices')),
	SHOWPRICES: lazy(() => import('../pages/prices/ShowPrices')),
};
const COMPLAINS = {
	COMPLAIN: lazy(() => import('../pages/complains/Complains')),
	COMPLAIN_SHOW: lazy(() => import('../pages/complains/ShowComplains')),
};

const CHECKOUTS = {
	CHECKOUT: lazy(() => import('../pages/checkouts/Checkout')),
};

const ADMINCHECKOUTS = {
	ADMINCHECKOUT: lazy(() => import('../pages/checkouts/AdminCheckout')),
};

const LOADPLANS = {
	LOADPLAN: lazy(() => import('../pages/loadplans/LoadPlan')),
	SHOWLOADPLAN: lazy(() => import('../pages/loadplans/ShowLoadPlan')),
};

const presentation = [
	/**
	 * Landing
	 */
	{
		path: dashboardMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
		exact: true,
	},
	{
		path: demoPages.page404.path,
		element: <AUTH.PAGE_404 />,
		exact: true,
	},
	{
		path: demoPages.login.path,
		element: <Login />,
		exact: true,
	},
	{
		path: demoPages.signUp.path,
		element: <Login />,
		exact: true,
	},

	/** ************************************************** */

	/**
	 * Page Layout Types
	 */

	// {
	// 	path: accounts.singlePages.subMenu.serviceInvoice.path,
	// 	element: <ACCOUNTS.SERVICE_INVOICE />,
	// 	exact: true,
	// },
	// {
	// 	path: accounts.singlePages.subMenu.vehicleInvoice.path,
	// 	element: <ACCOUNTS.VEHICLE_INVOICE />,
	// 	exact: true,
	// },

	{
		path: accounts.singlePages.subMenu.InvoiceSummery.path,
		element: <ACCOUNTS.INVOICE_SUMMARY />,
		exact: true,
	},
	// PAIN_INVOICE
	{
		path: accounts.singlePages.subMenu.PaidInvoice.path,
		element: <ACCOUNTS.PAID_INVOICE />,
		exact: true,
	},
	{
		path: accounts.singlePages.subMenu.PartialPaidInvoice.path,
		element: <ACCOUNTS.PARTIAL_PAID_INVOICE />,
		exact: true,
	},
	{
		path: accounts.singlePages.subMenu.UnpaidInvoice.path,
		element: <ACCOUNTS.UNPAID_INVOICE />,
		exact: true,
	},
	{
		path: 'accounts/invoices/:user_id',
		element: <ACCOUNTS.INVOICES />,
		exact: true,
	},

	{
		path: settings.singlePages.subMenu.user.path,
		element: <SETTINGS.USER />,
		exact: true,
	},
	{
		path: settings.singlePages.subMenu.role.path,
		element: <SETTINGS.ROLE />,
		exact: true,
	},
	{
		path: 'settings/roles-update',
		element: <SETTINGS.ROLE_UPDATE />,
		exact: true,
	},
	{
		path: 'settings/user-permission',
		element: <SETTINGS.USER_ROLE />,
		exact: true,
	},
	{
		path: settings.singlePages.subMenu.country.path,
		element: <SETTINGS.COUNTRY />,
		exact: true,
	},
	{
		path: settings.singlePages.subMenu.state.path,
		element: <SETTINGS.STATE />,
		exact: true,
	},
	{
		path: settings.singlePages.subMenu.city.path,
		element: <SETTINGS.CITY />,
		exact: true,
	},
	{
		path: settings.singlePages.subMenu.location.path,
		element: <SETTINGS.LOCATION />,
		exact: true,
	},
	{
		path: vehicles.singlePages.path,
		element: <VEHICLES.VEHICLE />,
		exact: true,
	},
	{
		path: '/vehicles/:id',
		element: <VEHICLES.SHOWVEHICLE />,
		exact: true,
	},
	{
		path: settings.singlePages.subMenu.ports.path,
		element: <PORTS.PORT />,
		exact: true,
	},
	{
		path: settings.singlePages.subMenu.port_of_loading.path,
		element: <PORT_OF_LOADING.PORT_LOADING />,
		exact: true,
	},
	{
		path: settings.singlePages.subMenu.port_of_discharge.path,
		element: <PORT_OF_DISCHARGE.PORT_DISCHARGE />,
		exact: true,
	},
	{
		path: settings.singlePages.subMenu.streamship_lines.path,
		element: <SETTINGS.STREAMSHIP_LINE />,
		exact: true,
	},
	{
		path: settings.singlePages.subMenu.auditLog.path,
		element: <SETTINGS.AUDIT />,
		exact: true,
	},
	{
		path: '/settings/activity-logs/:id',
		element: <SETTINGS.SHOWLOG />,
		exact: true,
	},
	{
		path: exports.singlePages.path,
		element: <EXPORTS.EXPORTS />,
		exact: true,
	},
	{
		path: '/exports/:id',
		element: <EXPORTS.SHOWEXPORT />,
		exact: true,
	},
	{
		path: consignee.singlePages.path,
		element: <CONSIGNEES.CONSIGNEE />,
		exact: true,
	},
	{
		path: '/consignees/:id',
		element: <CONSIGNEES.SHOWCONSIGNEE />,
		exact: true,
	},
	{
		path: '/notes',
		element: <NOTES.NOTE />,
		exact: true,
	},
	{
		path: 'notifications',
		element: <NOTIFICATIONS.NOTIFICATION />,
		exact: true,
	},
	{
		path: '/notifications/:id',
		element: <NOTIFICATIONS.SHOW_NOTIFICATION />,
		exact: true,
	},

	{
		path: profiles.singlePages.path,
		element: <PROFILES.PROFILE />,
		exact: true,
	},
	{
		path: customers.singlePages.path,
		element: <CUSTOMERS.CUSTOMER />,
		exact: true,
	},
	{
		path: '/customers/:id',
		element: <CUSTOMERS.SHOW_CUSTOMER />,
		exact: true,
	},
	{
		path: '/damage-claims/:id',
		element: <DAMAGECLAIMS.DAMAGECLAIM_SHOW />,
		exact: true,
	},
	{
		path: containers.singlePages.path,
		element: <CONTAINERS.CONTAINER />,
		exact: true,
	},
	{
		path: damageClaim.singlePages.path,
		element: <DAMAGECLAIMS.DAMAGECLAIM />,
		exact: true,
	},
	{
		path: pricing.singlePages.subMenu.shippingRate.path,
		element: <PRICES.SHIPPINGRATE />,
		exact: true,
	},
	{
		path: price.singlePages.path,
		element: <PRICES.PRICES />,
		exact: true,
	},
	{
		path: 'prices/:id',
		element: <PRICES.SHOWPRICES />,
		exact: true,
	},
	{
		path: '/shipping-rates/:id',
		element: <PRICES.SHOWSHIPPINGRATE />,
		exact: true,
	},
	{
		path: pricing.singlePages.subMenu.clearanceRate.path,
		element: <PRICES.CLEARANCE />,
		exact: true,
	},
	{
		path: pricing.singlePages.subMenu.towingRate.path,
		element: <PRICES.TOWING />,
		exact: true,
	},
	{
		path: '/towing-rates/:id',
		element: <PRICES.SHOWTOWINGRATE />,
		exact: true,
	},
	{
		path: complains.singlePages.path,
		element: <COMPLAINS.COMPLAIN />,
		exact: true,
	},
	{
		path: '/complains/:id',
		element: <COMPLAINS.COMPLAIN_SHOW />,
		exact: true,
	},
	{
		path: '/checkouts',
		element: <CHECKOUTS.CHECKOUT />,
		exact: true,
	},
	{
		path: '/admin-checkouts',
		element: <ADMINCHECKOUTS.ADMINCHECKOUT />,
		exact: true,
	},
	{
		path: loadPlan.singlePages.path,
		element: <LOADPLANS.LOADPLAN />,
		exact: true,
	},
	{
		path: 'load-plans/:id',
		element: <LOADPLANS.SHOWLOADPLAN />,
		exact: true,
	},
	{
		path: layoutMenu.blank.path,
		element: <PAGE_LAYOUTS.BLANK />,
		exact: true,
	},
	{
		path: layoutMenu.pageLayout.subMenu.headerAndSubheader.path,
		element: <PAGE_LAYOUTS.HEADER_SUBHEADER />,
		exact: true,
	},
	{
		path: layoutMenu.pageLayout.subMenu.onlyHeader.path,
		element: <PAGE_LAYOUTS.HEADER />,
		exact: true,
	},
	{
		path: layoutMenu.pageLayout.subMenu.onlySubheader.path,
		element: <PAGE_LAYOUTS.SUBHEADER />,
		exact: true,
	},
	{
		path: layoutMenu.pageLayout.subMenu.onlyContent.path,
		element: <PAGE_LAYOUTS.CONTENT />,
		exact: true,
	},
	{
		path: layoutMenu.asideTypes.subMenu.defaultAside.path,
		element: <PAGE_LAYOUTS.ASIDE />,
		exact: true,
	},
	{
		path: layoutMenu.asideTypes.subMenu.minimizeAside.path,
		element: <PAGE_LAYOUTS.MINIMIZE_ASIDE />,
		exact: true,
	},
];
const contents = [...presentation];

export default contents;
